import feature1 from "assets/images/feature/Free.jpeg"
import feature2 from "assets/images/feature/Watch.jpeg"
import feature3 from "assets/images/feature/Host.jpeg"
import feature4 from "assets/images/feature/SuperLikes.jpeg"
import feature5 from "assets/images/feature/SuperChat.jpeg"
import feature6 from "assets/images/feature/SuperDM.jpeg"
import feature7 from "assets/images/feature/Utility.jpeg"
import feature8 from "assets/images/feature/Shop.jpeg"
import feature9 from "assets/images/feature/Cryptocurrency.jpeg"

const Features = () => {
      // add features data in this array of object like this
      const featuresData = [
        { title: 'Free', bodyText: 'Create an account for free', img: feature1 },
        { title: 'Watch', bodyText: 'Browse live videos', img: feature2 },
        { title: 'Host', bodyText: 'Host a stream from anywhere', img: feature3 },
        { title: 'SuperLikes', bodyText: '1 Like = 1 Token', img: feature4 },
        { title: 'SuperChat', bodyText: 'Spend tokens to live chat', img: feature5 },
        { title: 'SuperDM', bodyText: 'DM your favourite creators', img: feature6 },
        { title: 'Utility', bodyText: 'Send rewards to any streamer', img: feature7 },
        { title: 'Shop', bodyText: 'Buy & sell physical or digital merchandise', img: feature8 },
        { title: 'Cryptocurrency', bodyText: 'Store crypto in your WeStream wallet', img: feature9 },
    ]
    return (
        <section id="features">
            <div className="container">
                <div className="sec-heading-wrapper">
                    {/* ============= main heading ================ */}
                    <h2 data-aos="fade-up" className="sec-heading">
                    App Features
                    </h2>
                </div>
            </div>
            <div className="feature-wrapper row">
                {featuresData.map((data, ind) => {
                    return (
                        <div data-aos="fade-up" key={ind} className="row column feature-card">
                            <img src={data.img} alt={data.title} />
                            <div className="feature-card-body row column">
                                <h2>{data.title}</h2>
                                <p className="role-">{data.bodyText}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </section>
    );
};

export default Features;
